export default function checkLoginErrorMsg(msg) {
  if (msg === "Unable to find user details") {
    return "No such username or password";
  } else {
    return msg;
  }
}


// WEBPACK FOOTER //
// ./src/utils/checkLoginErrorMsg.js